/**
 * Access Control Utilities
 * Handles free vs paid user access throughout the app
 */

// Check if user has paid access
export const hasPaidAccess = (user) => {
  if (!user) return false;
  
  // Check if user has a subscription status
  // This would be populated from backend when Stripe integration is added
  return user.subscription_status === 'active' || user.subscription_status === 'trialing';
};

// Check if user is on free plan
export const isFreePlan = (user) => {
  if (!user) return true;
  return !hasPaidAccess(user);
};

// Check if user can access clinical tracking
export const canAccessClinicalTracking = (user, entryCount = 0) => {
  if (hasPaidAccess(user)) return true;
  
  // Free users limited to 3 entries
  return entryCount < 3;
};

// Check if user can export
export const canExport = (user) => {
  return hasPaidAccess(user);
};

// Check if user can access notes
export const canAccessNotes = (user) => {
  return hasPaidAccess(user);
};

// Check if content should be blurred
export const shouldBlurContent = (user, contentType = 'default') => {
  if (hasPaidAccess(user)) return false;
  
  // Free users see blurred content
  return true;
};

// Get upgrade message based on context
export const getUpgradeMessage = (context) => {
  const messages = {
    tracking: 'Unlock unlimited tracking with Companion access',
    export: 'Unlock PDF exports with Companion access',
    notes: 'Unlock private notes with Companion access',
    content: 'Unlock full content with Companion access',
    default: 'Unlock full access with Companion'
  };
  
  return messages[context] || messages.default;
};
